import { render } from "./TestimonialSlider.vue?vue&type=template&id=60769fd2&scoped=true"
import script from "./TestimonialSlider.vue?vue&type=script&lang=js"
export * from "./TestimonialSlider.vue?vue&type=script&lang=js"

import "./TestimonialSlider.vue?vue&type=style&index=0&id=60769fd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60769fd2"]])

export default __exports__